import React, { useState } from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import CheckIcon from '@material-ui/icons/Check';
import handleOpenWhatsApp from 'services/whatsappService';
import {
  FARMA,
  nextSteps,
  WHATSAPP_DEFAULT,
  WHATSAPP_PHONE,
} from '../farmaferContent';

const copyText = async (value) => {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(value);
    return;
  }
  const el = document.createElement('textarea');
  el.value = value;
  el.setAttribute('readonly', '');
  el.style.position = 'absolute';
  el.style.left = '-9999px';
  document.body.appendChild(el);
  el.select();
  document.execCommand('copy');
  document.body.removeChild(el);
};

const NextSteps = () => {
  const [copiedEmail, setCopiedEmail] = useState(false);

  const handleCopyEmail = async () => {
    try {
      await copyText(nextSteps.driveEmail);
      setCopiedEmail(true);
      window.setTimeout(() => setCopiedEmail(false), 1800);
    } catch (err) {
      // clipboard may be blocked
    }
  };

  return (
    <Box
      component="section"
      id="siguientes-pasos"
      py={{ xs: 7, md: 10 }}
      px={{ xs: 2.5, sm: 4, md: 7 }}
      bgcolor={FARMA.mint}
    >
      <Box maxWidth={1100} mx="auto">
        <Typography
          sx={{
            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
            fontWeight: 700,
            letterSpacing: '0.12em',
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            color: FARMA.green,
            mb: 1.25,
          }}
        >
          {nextSteps.overline}
        </Typography>
        <Typography
          component="h2"
          sx={{
            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
            fontWeight: 800,
            letterSpacing: '-0.03em',
            fontSize: { xs: '1.85rem', md: '2.55rem' },
            color: FARMA.ink,
            mb: 1.25,
            maxWidth: 640,
          }}
        >
          {nextSteps.title}
        </Typography>
        <Typography
          sx={{
            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
            color: FARMA.inkMuted,
            fontSize: { xs: '1.05rem', md: '1.12rem' },
            lineHeight: 1.65,
            maxWidth: 560,
            mb: { xs: 4, md: 5 },
          }}
        >
          {nextSteps.subtitle}
        </Typography>

        <Grid container spacing={3} mb={4}>
          {nextSteps.steps.map((step) => (
            <Grid item xs={12} md={step.materials ? 12 : 6} key={step.id}>
              <Box>
                <Typography
                  sx={{
                    fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                    fontWeight: 800,
                    fontSize: { xs: '2.5rem', md: '3rem' },
                    color: FARMA.greenSoft,
                    opacity: 0.35,
                    lineHeight: 1,
                    mb: 1,
                  }}
                >
                  {step.n}
                </Typography>
                <Typography
                  component="h3"
                  sx={{
                    fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                    fontWeight: 800,
                    fontSize: '1.35rem',
                    color: FARMA.ink,
                    mb: 1,
                  }}
                >
                  {step.title}
                </Typography>
                <Typography
                  sx={{
                    fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                    color: FARMA.inkMuted,
                    lineHeight: 1.7,
                    fontSize: '1.02rem',
                    maxWidth: step.materials ? 720 : 'none',
                  }}
                >
                  {step.text}
                </Typography>

                {step.materials ? (
                  <Box mt={2.5}>
                    <Box
                      display="flex"
                      alignItems="center"
                      flexWrap="wrap"
                      mb={2}
                      sx={{ gap: 1.25 }}
                    >
                      <Typography
                        sx={{
                          fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                          fontWeight: 700,
                          fontSize: '0.95rem',
                          color: FARMA.ink,
                        }}
                      >
                        Comparte la carpeta con
                      </Typography>
                      <Box
                        display="inline-flex"
                        alignItems="center"
                        px={1.5}
                        py={0.75}
                        borderRadius={1.25}
                        bgcolor={FARMA.white}
                        border={`1px solid ${copiedEmail ? FARMA.greenSoft : FARMA.sand}`}
                        sx={{ gap: 1 }}
                      >
                        <Typography
                          sx={{
                            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                            fontWeight: 700,
                            color: FARMA.greenDeep,
                            fontSize: '0.98rem',
                          }}
                        >
                          {nextSteps.driveEmail}
                        </Typography>
                        <Button
                          type="button"
                          size="small"
                          variant={copiedEmail ? 'contained' : 'outlined'}
                          startIcon={
                            copiedEmail ? <CheckIcon /> : <FileCopyOutlinedIcon />
                          }
                          onClick={handleCopyEmail}
                          sx={{
                            borderRadius: 1.25,
                            fontWeight: 800,
                            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                            textTransform: 'none',
                            minWidth: 0,
                            px: 1.5,
                            borderColor: FARMA.green,
                            color: copiedEmail ? FARMA.white : FARMA.green,
                            bgcolor: copiedEmail ? FARMA.green : 'transparent',
                            '&:hover': {
                              borderColor: FARMA.greenDeep,
                              bgcolor: copiedEmail ? FARMA.greenDeep : FARMA.white,
                              color: copiedEmail ? FARMA.white : FARMA.greenDeep,
                            },
                          }}
                        >
                          {copiedEmail ? 'Copiado' : 'Copiar'}
                        </Button>
                      </Box>
                    </Box>

                    <Typography
                      sx={{
                        fontFamily: '"Outfit", "Source Sans 3", sans-serif',
                        fontWeight: 700,
                        fontSize: '0.85rem',
                        letterSpacing: '0.04em',
                        textTransform: 'uppercase',
                        color: FARMA.green,
                        mb: 1.25,
                      }}
                    >
                      Incluye en la carpeta
                    </Typography>
                    <Box
                      component="ul"
                      sx={{
                        m: 0,
                        pl: 2.25,
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                        gap: 1,
                      }}
                    >
                      {step.materials.map((item) => (
                        <Typography
                          component="li"
                          key={item}
                          sx={{
                            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
                            color: FARMA.inkMuted,
                            lineHeight: 1.55,
                            fontSize: '0.98rem',
                          }}
                        >
                          {item}
                        </Typography>
                      ))}
                    </Box>
                  </Box>
                ) : null}
              </Box>
            </Grid>
          ))}
        </Grid>

        <Button
          variant="contained"
          size="large"
          startIcon={<WhatsAppIcon />}
          onClick={() => handleOpenWhatsApp(null, WHATSAPP_DEFAULT, WHATSAPP_PHONE)}
          sx={{
            px: 3.5,
            py: 1.5,
            borderRadius: 1.5,
            fontWeight: 800,
            fontFamily: '"Outfit", "Source Sans 3", sans-serif',
            bgcolor: FARMA.green,
            color: FARMA.white,
            boxShadow: '0 14px 32px rgba(10,107,74,0.28)',
            '&:hover': { bgcolor: FARMA.greenDeep },
          }}
        >
          {nextSteps.cta}
        </Button>

        <Typography
          sx={{
            mt: 5,
            fontFamily: '"Source Sans 3", "Outfit", sans-serif',
            fontSize: '0.85rem',
            color: FARMA.inkMuted,
          }}
        >
          {nextSteps.copyright}
        </Typography>
      </Box>
    </Box>
  );
};

export default NextSteps;
